import Vue from 'vue';
import VueI18n from 'vue-i18n';
import moment from 'moment';
import { getCookie, setCookie } from '@/libs/cookie';
import config from '@/config';

// 简体中文
import cn from './lang/zh-CN/index.js';
// 英文
import en from './lang/en-US/index.js';

// 获取本地缓存语言
const cookieLocale = config.defaultLocale || getCookie('locale');
setCookie('locale', cookieLocale);
setCookie('m-locale', cookieLocale);

moment.locale(cookieLocale);

Vue.use(VueI18n);
const messages = {
  'zh-CN': {
    ...cn,
  },
  'en-US': {
    ...en,
  },
};

Vue.locale = () => {};

// vue-i18n 6.x+写法
const i18n = new VueI18n({
  locale: cookieLocale,
  messages: messages,
});

export default i18n;
